import React from 'react';
import { BulbOutlined } from '@ant-design/icons';

export default function ChatWorkspaceCanonicalActions({
  actionEntries = [],
  handleCanonicalActionSelect,
}) {
  const resolvedActions = Array.isArray(actionEntries)
    ? actionEntries.filter((item) => item && typeof item === 'object')
    : [];
  if (resolvedActions.length === 0) {
    return null;
  }
  return (
    <div className="flare-workspace-mode-hint" style={{ marginBottom: 8 }}>
      <span className="flare-workspace-mode-hint-icon" aria-hidden="true">
        <BulbOutlined />
      </span>
      <span className="flare-workspace-mode-hint-title">
        可继续执行的下一步
      </span>
      <span className="flare-workspace-mode-hint-actions">
        {resolvedActions.map((actionItem, index) => (
          <button
            className="flare-workspace-mode-hint-apply"
            type="button"
            key={actionItem.key || actionItem.text || index}
            onClick={() => {
              if (typeof handleCanonicalActionSelect === 'function') {
                handleCanonicalActionSelect(actionItem);
              }
            }}
          >
            {actionItem.text || '继续'}
          </button>
        ))}
      </span>
    </div>
  );
}
